// src/config.js
// Build 2 (Phase 1): named tunables centralized out of the scoring path.
// Same literal values as the Build-1 verified state (commit ea04d70) — behavior-identical.
// Covers ATR exit multipliers, RSI momentum zones + overbought, and the profit floor/ceiling.
// Tag tiers and mode cutoffs are now centralized here as well (Build 3): single-source,
// behavior-identical to commit 97a2110 — same literals, relocated out of the one consolidated
// grading block. The ===10 / >=9 / >=6 / else ATR branch ORDER is unchanged; each branch simply
// reads its multiplier from here.

export const CONFIG = {
  atrExit: { tier3: 3, tier2: 2, tier1_5: 1.5, tier1: 1 },
  rsi: {
    overbought: 75,
    zones: {
      low:  { min: 54, max: 60 },
      mid:  { min: 61, max: 67 },
      high: { min: 68, max: 70 },
    },
  },
  profitTarget: { low: 0.5, high: 5 },
  tagTiers:    { breakout: 13, strong: 10, highPotential: 8, watchlist: 6, risky: 4 },
  // NOTE: as of Phase 6 Build D, modeCutoffs NO LONGER governs server delivery — fanout/modesClearedBy
  // now uses grade-set membership (worker.cjs). Read ONLY by the App.js front-end now.
  modeCutoffs: { Conservative: 9, Moderate: 7, Aggressive: 6 },
};
